// extracted by mini-css-extract-plugin
module.exports = {"margin":"Icon_margin__38G5G","active":"Icon_active__2J5Z3","full":"Icon_full__2kfcv","fill":"Icon_fill__381RK"};